'use strict';

var React = require('react'),
    createStoreMixin = require('../mixins/createStoreMixin'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    PlayerActionCreators = require('../actions/PlayerActionCreators'),
    PlayerStore = require('../stores/PlayerStore'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    BlurredBackground = require('../atoms/BlurredBackground'),
    Icon = require('../atoms/Icon'),
    Button = require('../atoms/Button'),
    Loader = require('../atoms/Loader'),
    formatTime = require('../utils/formatTime'),
    ResponsiveImageQueueMixin = require('../mixins/ResponsiveImageQueueMixin'),
    ViewportTestMixin = require('../mixins/ViewportTestMixin'),
    MediaTypes = require('../constants/MediaTypes'),
    { isMobile } = require('../utils/Browser'),
    { PropTypes } = React;

require('./legacy/Stamp.less');
require('./Video.less');

var IMAGE_SIZES = {
  'default': 480,
  'xs': 640,
  'sm': 992,
  'md': 1024,
  'lg': 1024,
  'xl': 1280
};

var Video = React.createClass({
  mixins: [
    createStoreMixin(PlayerStore),
    ResponsiveImageQueueMixin,
    ViewportTestMixin,
    ClassNameMixin,
    PureRenderMixin
  ],

  propTypes: {
    stamp: PropTypes.object.isRequired,
    uuid: PropTypes.string.isRequired,
    sourceId: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    background: PropTypes.shape({
      url: PropTypes.string.isRequired,
      size: PropTypes.object.isRequired,
      colors: PropTypes.object.isRequired
    }).isRequired
  },

  className: 'stamp-Video',

  getMediaId() {
    return this.props.uuid;
  },

  getEmbedMaxHeight() {
    var height = (this.props.height < 960 / this.props.width * this.props.height) ?
      this.props.height :
      960 / this.props.width * this.props.height;

    return height < 540 ? 540 : height;
  },

  getInitialState() {
    return {
      hasPressedPlay: false,
      isLoaded: false
    };
  },

  getStateFromStores() {
    return {
      isPlaying: PlayerStore.isPlaying(this.getMediaId())
    };
  },

  getCSSModifiers() {
    var { hasPressedPlay, isLoaded } = this.state,
        isReady = hasPressedPlay && (isLoaded || isMobile());

    return [
      hasPressedPlay && 'pressedPlay',
      isReady && 'ready'
    ];
  },

  getContentWindow() {
    return this.refs.iframe.getDOMNode().contentWindow;
  },

  getImageSizes() {
    return IMAGE_SIZES;
  },

  getImageOptions() {
    const devicePixelRatio = (typeof window !== 'undefined') ? window.devicePixelRatio : 1;

    return {
      image: this.props.background,
      sizes: {
        thumb: true,
        small: this.state.imageSize > 500,
        normal: true,
        retina: devicePixelRatio > 1.5 && this.state.isInViewport
      }
    };
  },

  componentDidMount() {
    window.addEventListener('message', this.handleIframeMessage);
  },

  componentWillUpdate(nextProps, nextState) {
    if (this.state.isPlaying && !nextState.isPlaying) {
      this.postMessage('pause');
    } else if (!this.state.isPlaying && nextState.isPlaying) {
      this.postMessage('play');
    }
  },

  componentDidUpdate(prevProps, prevState) {
    if (prevState.isInViewport !== this.state.isInViewport) {
      this.updateImageQueue();
    }
  },

  componentWillUnmount() {
    this.pause();
    window.removeEventListener('message', this.handleIframeMessage);
    this.clearIdleTimeout();
  },

  render() {
    var src = `https://player.vimeo.com/video/${this.props.sourceId}`,
        height = this.getEmbedMaxHeight();

    return (
      <div className={this.getClassName()}
           onClick={this.handlePlayClick}
           data-scroll-anchor>

        <div className='stamp-Video-bg'
             style={{
               backgroundImage: this.getBackgroundImageUrl()
             }} />

        <div className='stamp-Video-blurredBg'>
          <BlurredBackground background={this.props.background} />
        </div>

        {this.renderLoaderImg()}

        <div className='stamp-Video-box'>

          <div className='stamp-Video-embed'
               style={{
                paddingBottom: (height * 100 / 960) + '%'
               }}>

            <iframe src={src}
                    frameBorder='0'
                    webkitAllowFullScreen
                    mozAllowFullscreen
                    allowFullScreen
                    ref='iframe' />

            {!this.state.isLoaded &&
              <div className='stamp-Video-play'>
                {this.state.hasPressedPlay ?
                  !isMobile() && <Loader absoluteCenter /> :
                  <Button absoluteCenter
                          context='Video'
                          onClick={this.handlePlayClick}
                          size='xxxlarge'
                          color='black'
                          overlay
                          round>
                    <Icon name='play'
                          mode='stroke'
                          size='large' />

                    <div className='stamp-Video-duration utils--hideOnMobile'>
                      {formatTime(this.props.duration)}
                    </div>
                  </Button>
                }
              </div>
            }
          </div>
        </div>

        <div className='stamp-Video-meta'>
          <div className='stamp-Video-title'>{this.props.title}</div>
          <div className='stamp-Video-author'>{this.props.username}</div>
        </div>
      </div>
    );
  },

  handlePlayClick(e) {
    e.stopPropagation();

    this.setState({
      hasPressedPlay: true
    });

    if (!this.state.isLoaded) {
      this.play();
      this.setIdleTimeout();
      return;
    }

    if (this.state.isPlaying) {
      this.pause();
    } else {
      this.play();
    }
  },

  setIdleTimeout() {
    if (!this.idleTimeout) {
      this.idleTimeout = setTimeout(this.handleVideoIdle, 5000);
    }
  },

  clearIdleTimeout() {
    if (this.idleTimeout) {
      clearTimeout(this.idleTimeout);
    }
  },

  handleVideoIdle() {
    // Go ahead and show iframe if user waited too long
    this.setState({
      isLoaded: true
    });
  },

  handleIframeMessage(e) {
    if (!this.isMounted()) {
      return;
    }

    if (e.source !== this.getContentWindow()) {
      return;
    }

    var data = null;
    try {
      data = JSON.parse(e.data);
    } catch (err) {
      // For some reason, this happens from time to time
      return;
    }

    switch (data.event) {
    case 'ready':
      this.postMessage('addEventListener', 'play');
      this.postMessage('addEventListener', 'playProgress');
      this.postMessage('addEventListener', 'pause');
      this.postMessage('addEventListener', 'finish');
      break;

    case 'play':
      this.play();
      break;

    case 'playProgress':
      this.handleVideoProgress(data.data);
      break;

    case 'pause':
    case 'finish':
      this.pause();
      break;
    }
  },

  handleVideoProgress: function (data) {
    if (!this.state.isLoaded) {
      this.setState({ isLoaded: true });
    }

    // We want to rewind instead of showing related videos.
    // It's too late to do this in `finish` handler or when `data.progress` is 1.
    if (data.duration - data.seconds > 0.3) {
      return;
    }

    this.rewind();

    // Prevents play button stuck in "playing" state in Firefox:
    requestAnimationFrame(() => {
      this.postMessage('pause');
    });
  },

  rewind() {
    // This works better than sending `unload` because it doesn't flicker.
    this.postMessage('seekTo', 0);
    this.postMessage('pause');
  },

  play() {
    PlayerActionCreators.play(this.getMediaId(), {
      mediaType: MediaTypes.VIDEO,
      stampId: this.props.stamp.id
    });
  },

  pause() {
    PlayerActionCreators.pause(this.getMediaId());
  },

  postMessage(action, value) {
    var data = {
      method: action,
      value: value
    };

    var message = JSON.stringify(data),
        contentWindow = this.getContentWindow(),
        url = `https://player.vimeo.com/video/${this.props.sourceId}`;

    contentWindow.postMessage(message, url);
  }
});

module.exports = Video;



/** WEBPACK FOOTER **
 ** ./stamp/Video.jsx
 **/